// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".student__label[data-v-0d45c3b1] {\n  font-weight: normal;\n  font-size: 14px;\n  color: #727272;\n}\n.student__label_icon[data-v-0d45c3b1] {\n  margin-left: -0.9rem;\n}\n.student__info[data-v-0d45c3b1] {\n  font-weight: normal;\n  font-size: 16px;\n  color: #11291b;\n}", ""]);
// Exports
module.exports = exports;
